import * as R from "ramda";
import { validateObject, validateField } from "util/validation";
import { notBlank } from "../util/ext";
import { curry } from "ramda";

const detailConstraints = {
  organizationName: {
    presence: {
      allowEmpty: false,
      message: "^Organization Name must not be blank.",
    },
  },
  alias: {
    length: {
      maximum: 63,
      message: "^Alias maximum length is %{count} characters.",
    },
  },
};

const profileConstraints = {
  offlineBookshelfMax: {
    numericality: {
      onlyInteger: true,
      message: "^Offline Bookshelf Max must be an positive integer.",
      greaterThanOrEqualTo: 0,
    },
  },
};

const propertyConstraints = {
  key: {
    presence: {
      allowEmpty: false,
      message: "^A Property Key must be selected or a new one entered.",
    },
  },
  value: {
    presence: {
      allowEmpty: false,
      message: "^A Property Value must be selected or a new value entered.",
    },
  },
};

const associatedConstraints = {
  associatedOrganizationId: {
    presence: {
      allowEmpty: false,
      message: "^An Organization must be selected.",
    },
  },
  credentialType: {
    presence: {
      allowEmpty: false,
      message: "^A Credential Type must be selected.",
    },
  },
};

const contentProviderConstraints = {
  contentProviderId: {
    presence: {
      allowEmpty: false,
      message: "^A Content Provider Id is required.",
    },
  },
};

const buyingGroupMemberConstraints = {
  memberId: {
    presence: {
      allowEmpty: false,
      message: "^A Member Organization must be selected",
    },
  },
};

const salesAccountConstraints = {
  nimbleAccountNumber: {
    numericality: {
      onlyInteger: true,
      message: "^Nimble Account Number must be an positive integer.",
      greaterThanOrEqualTo: 0,
    },
  },
};

const applicationAccessConstraints = {};

const locationConstraints = {};

export const validateDetailsField = (field, value, errors = {}) =>
  validateField(detailConstraints, field, value, errors);

export const validateDetails = R.partial(validateObject, [detailConstraints]);

export const validateSalesAccountField = (field, value, errors = {}) =>
  validateField(salesAccountConstraints, field, value, errors);

export const validateSalesAccount = R.partial(validateObject, [
  salesAccountConstraints,
]);

export const validateProfileField = (field, value, errors = {}) =>
  validateField(profileConstraints, field, value, errors);

export const validateProfile = R.partial(validateObject, [profileConstraints]);

export const validatePropertiesField = (field, value, errors = {}) =>
  validateField(propertyConstraints, field, value, errors);

export const validateProperties = R.partial(validateObject, [
  propertyConstraints,
]);

export const validateAssociatedField = (field, value, errors = {}) =>
  validateField(associatedConstraints, field, value, errors);

export const validateAssociated = R.partial(validateObject, [
  associatedConstraints,
]);

export const validateContentProviderField = (field, value, errors = {}) =>
  validateField(contentProviderConstraints, field, value, errors);

export const validateContentProvider = R.partial(validateObject, [
  contentProviderConstraints,
]);

export const validateLocationField = (field, value, errors = {}) =>
  validateField(locationConstraints, field, value, errors);

export const validateLocation = R.partial(validateObject, [
  locationConstraints,
]);

export const validateApplicationAccessField = (field, value, errors = {}) =>
  validateField(applicationAccessConstraints, field, value, errors);

export const validateApplicationAccess = R.partial(validateObject, [
  applicationAccessConstraints,
]);

export const validateBuyingGroupMemberField = (field, value, errors = {}) =>
  validateField(buyingGroupMemberConstraints, field, value, errors);

export const validateBuyingGroupMember = R.partial(validateObject, [
  buyingGroupMemberConstraints,
]);

export const hasError = curry(
  (errors, field) => notBlank(errors) && notBlank(errors[field]),
);

export const firstError = curry((errors, field) =>
  notBlank(errors) && notBlank(errors[field]) ? errors[field][0] : "",
);
